import {
  Input, Modal, Table, ScrollArea, Text, Badge,
  Checkbox, Button
} from "@mantine/core";
import B2BButton from "../../common/B2BButton";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";

const Return = ({ item, order, setOrder, returnModalClose, comfirmReturn }) => {
  console.log(order, 'itemsssssss')
  const [visible, { open, close }] = useDisclosure(false);
  const [rollModalOpen, { open: openRollModal, close: closeRollModal }] = useDisclosure(false);
  const [selectedPickIndex, setSelectedPickIndex] = useState(null);
  const [error, setError] = useState("");
  const isAlreadyReturned = item?.returnStatus || false;
  const selectedItem = order?.items?.find(i => i.id === item?.id);
  const [reasonModalOpen, { open: openReasonModal, close: closeReasonModal }] = useDisclosure(false);
  const [selectedReasonIndex, setSelectedReasonIndex] = useState(null);
  const [tempReason, setTempReason] = useState("");
  const isViewMode = item?.returnStatus === true;
  const pickListChange = (event, key, pickIndex) => {
    let value = event?.target?.value;

    setOrder(prev => ({
      ...prev,
      items: prev.items.map(currentItem =>
        currentItem.id === item.id
          ? {
            ...currentItem,
            pickList: currentItem.pickList.map((pick, pIdx) => {
              if (pIdx !== pickIndex) return pick;

              if (key === "returnedRolls") {
                const max = parseInt(pick.noOfRoll || 0);
                const numValue = parseInt(value || 0);

                if (numValue > max) {
                  value = max;
                }

                if (numValue < 0) {
                  value = 0;
                }
              }

              return {
                ...pick,
                [key]: value,
                rolls:
                  key === "returnedRolls"
                    ? pick.rolls.map(r => ({ ...r, selected: false }))
                    : pick.rolls
              };
            })
          }
          : currentItem
      )
    }));
  };
  const isReasonMissing = selectedItem?.pickList?.some(pick => {
    const entered = parseInt(pick?.returnedRolls || 0);
    if (entered > 0) {
      return !pick.reason || pick.reason.trim() === "";
    }

    return false;
  });
  const handleRollSelect = (pickIndex, rollIndex) => {
    setOrder(prev => ({
      ...prev,
      items: prev.items.map(currentItem =>
        currentItem.id === item.id
          ? {
            ...currentItem,
            pickList: currentItem.pickList.map((pick, pIdx) => {
              if (pIdx !== pickIndex) return pick;

              const currentSelected = pick.rolls.filter(r => r.selected).length;
              const maxAllowed = parseInt(pick.returnedRolls || 0);

              return {
                ...pick,
                rolls: pick.rolls.map((roll, rIdx) => {
                  if (rIdx !== rollIndex) return roll;
                  if (!roll.selected && currentSelected >= maxAllowed) return roll;
                  return { ...roll, selected: !roll.selected };
                })
              };
            })
          }
          : currentItem
      )
    }));
  };

  const handleOpenRollSelection = (pickIndex) => {
    setSelectedPickIndex(pickIndex);
    openRollModal();
  };

  const handleCloseRollModal = () => {
    closeRollModal();
    setSelectedPickIndex(null);
  };

  useEffect(() => {
    if (item?.pickList) {
      setOrder(prev => ({
        ...prev,
        items: prev.items.map(currentItem =>
          currentItem.id === item.id
            ? {
              ...currentItem,
              pickList: currentItem.pickList.map(pick => ({
                ...pick,
                returnedRolls: pick.returnedRolls || "",
                reason: pick.reason || "",
                rolls: pick.rolls?.map(roll => ({
                  ...roll,
                  selected: roll.selected || false
                })) || []
              }))
            }
            : currentItem
        )
      }));
    }
  }, [item?.id]);


  useEffect(() => {
    let errorMsg = "";
    selectedItem?.pickList?.forEach((pick) => {
      const entered = parseInt(pick?.returnedRolls || 0);
      const selected = pick.rolls?.filter(r => r.selected).length || 0;
      if (entered > 0 && entered !== selected) {
        errorMsg = `Batch ${pick.batch}: Please select exactly ${entered} roll(s)`;
      }
    });
    setError(errorMsg);
  }, [selectedItem?.pickList]);



  const totalReturningRolls = selectedItem?.pickList?.reduce(
    (total, pick) => total + (parseInt(pick?.returnedRolls) || 0), 0
  ) || 0;

  const currentBatch = selectedPickIndex !== null
    ? selectedItem?.pickList?.[selectedPickIndex]
    : null;

  return (
    <>
      <Table
        border={1}
        highlightOnHover
        withTableBorder
        striped
        styles={{
          td: {
            padding: "14px 16px",
            textAlign: "center",
            verticalAlign: "middle"
          },
          th: {
            padding: "14px 16px",
            textAlign: "center",
            verticalAlign: "middle"
          }
        }}
      >
        <thead>
          <tr>
            <th>Product Name</th>
            <th>Batch</th>
            <th>No. of Rolls Ordered</th>
            <th>Returning No. of Rolls</th>
            <th>Selected Rolls</th>
            <th>Reason</th>
          </tr>
        </thead>

        <tbody>
          {selectedItem?.pickList?.map((batchItem, pickIndex) => {
            console.log(item, batchItem, "xcccccccc")
            const selectedCount = batchItem.rolls?.filter(r => r.selected).length || 0;
            const targetCount = parseInt(batchItem.returnedRolls) || 0;

            const returnedRollsList = batchItem.rolls?.filter(r => r.returnedRoll);

            return (
              <tr key={`${batchItem.batch}-${pickIndex}`}>

                <td><div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  {selectedItem.productVariant?.name || item.productVariant?.name}</div>
                </td>

                <td><div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}><strong>{batchItem.batch}</strong></div></td>

                <td><div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>{batchItem.noOfRoll}</div></td>

                <td><div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  {isViewMode ? (
                    <Badge color="green" variant="light">
                      {batchItem.returnedRolls || returnedRollsList?.length || 0}
                    </Badge>
                  ) : (
                    <Input
                      type="number"
                      min="0"
                      max={batchItem.noOfRoll}
                      value={batchItem.returnedRolls || ""}
                      onChange={(e) => pickListChange(e, "returnedRolls", pickIndex)}
                      disabled={isAlreadyReturned}
                    />
                  )}</div>
                </td>

                <td><div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  {isViewMode ? (
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      {returnedRollsList?.length > 0 ? (
                        returnedRollsList.map((roll) => (
                          <Badge key={roll.id} size="xs" color="green" variant="light">
                            {roll.rollId}
                          </Badge>
                        ))
                      ) : (
                        <Text size="xs" c="dimmed">No rolls returned</Text>
                      )}
                    </div>
                  ) : (
                    <Button
                      size="xs"
                      onClick={() => handleOpenRollSelection(pickIndex)}
                      disabled={!batchItem.returnedRolls}
                    >
                      {selectedCount === targetCount && targetCount > 0
                        ? `Selected ✓ (${selectedCount})`
                        : `Select ${selectedCount} / ${targetCount}`}
                    </Button>
                  )}</div>
                </td>
                <td><div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  {isViewMode ? (
                    <Text size="sm">
                      {batchItem.reason || "-"}
                    </Text>
                  ) : (
                    <Button
                      size="xs"
                      onClick={() => {
                        setSelectedReasonIndex(pickIndex);
                        setTempReason(batchItem.reason || "");
                        openReasonModal();
                      }}
                    >
                      {batchItem.reason ? "Edit Reason" : "Add Reason"}
                    </Button>
                  )}</div>
                </td>

              </tr>
            );
          })}
        </tbody>
      </Table>
      {!isViewMode && (
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1rem", gap: "1rem" }}>
          <B2BButton type="button" color="red" name="Cancel" onClick={returnModalClose} />
          <B2BButton
            type="button"
            name={isAlreadyReturned ? "Already Returned" : "Proceed to Return"}
            color="#8BC53F"
            onClick={open}
            disabled={
              isAlreadyReturned ||
              !!error ||
              totalReturningRolls <= 0 ||
              isReasonMissing
            }
          />
        </div>)}

      <Modal
        opened={rollModalOpen}
        onClose={handleCloseRollModal}
        title={`Select Rolls - Batch ${currentBatch?.batch}`}
        size="md"
        centered
        styles={{
          body: { padding: '8px 14px 6px' },
          header: { paddingBottom: '6px' }
        }}
      >
        {currentBatch && (
          <>
            <Text mb={8} size="sm" fw={500}>
              Select exactly <strong>{parseInt(currentBatch.returnedRolls) || 0}</strong> rolls
            </Text>

            <ScrollArea h={360} scrollbarSize={6} offsetScrollbars>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
                {currentBatch.rolls?.map((roll, rollIndex) => {
                  const isSelected = roll.selected || false;
                  const currentSelectedCount = currentBatch.rolls.filter(r => r.selected).length;
                  const maxAllowed = parseInt(currentBatch.returnedRolls) || 0;

                  return (
                    <div
                      key={roll.id || roll.rollId}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '8px 12px',
                        border: '1px solid #e9ecef',
                        borderRadius: '7px',
                        backgroundColor: isSelected ? '#f0fdf4' : '#fff',
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1 }}>
                        <Checkbox
                          checked={isSelected}
                          onChange={() => handleRollSelect(selectedPickIndex, rollIndex)}
                          disabled={!isSelected && currentSelectedCount >= maxAllowed}
                          size="sm"
                        />
                        <div>
                          <Text fw={600} size="sm">{roll.rollId}</Text>
                          <Text size="10px" c="dimmed">
                            BARCODE : {roll.barcode || 'N/A'}
                          </Text>
                        </div>
                      </div>

                      {isSelected && (
                        <Badge color="green" size="xs" variant="light">✓</Badge>
                      )}
                    </div>
                  );
                })}
              </div>
            </ScrollArea>

            <div style={{
              position: 'sticky',
              bottom: 0,
              background: '#fff',
              marginTop: '10px',
              padding: '10px 6px',
              borderTop: '1px solid #e9ecef',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              zIndex: 10
            }}>
              <Text size="sm" fw={600}>
                Selected: <span style={{ color: '#40C057' }}>
                  {currentBatch.rolls?.filter(r => r.selected).length || 0}
                </span> / {parseInt(currentBatch.returnedRolls) || 0}
              </Text>

              <Button
                variant="filled"
                size="xs"
                onClick={handleCloseRollModal}
              >
                Done
              </Button>
            </div>
          </>
        )}
      </Modal>

      <Modal
        opened={visible}
        onClose={close}
        title="Confirm Return"
        centered
        size="md"
      >
        <Text ta="center" size="lg" mb="xl">
          Confirm return of selected rolls?
        </Text>
        <div style={{ display: "flex", justifyContent: "center", gap: "1rem", marginTop: "1rem" }}>
          <B2BButton type="button" color="red" name="Cancel" onClick={close} />
          <B2BButton
            type="button"
            name="Confirm Return"
            color="#8BC53F"
            onClick={() => comfirmReturn(selectedItem)}
          />
        </div>
      </Modal>
      <Modal
        opened={reasonModalOpen}
        onClose={closeReasonModal}
        title="Enter Return Reason"
        centered
        size="md"
      >
        <Input.Wrapper label="Reason" mb="sm">
          <textarea
            value={tempReason}
            onChange={(e) => setTempReason(e.target.value)}
            placeholder="Type detailed reason..."
            style={{
              width: "100%",
              minHeight: "120px",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ced4da",
              resize: "vertical"
            }}
          />
        </Input.Wrapper>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          <Button type="button" color="red" name="Cancel" onClick={closeReasonModal}>
            Cancel
          </Button>

          <Button
            color="#8BC53F"
            onClick={() => {
              if (selectedReasonIndex !== null) {
                pickListChange(
                  { target: { value: tempReason } },
                  "reason",
                  selectedReasonIndex
                );
              }
              closeReasonModal();
            }}
          >
            Save
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default Return;